"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function getColorFallback(theme, colorKey = 'primary') {
    if (['low', 'high'].includes(colorKey)) {
        return theme.neutralColor[colorKey];
    }
    if (['positive', 'negative', 'warning', 'informative'].includes(colorKey)) {
        return theme.feedbackColor[colorKey];
    }
    return theme.brandColor[colorKey];
}
exports.default = getColorFallback;
